export const parseEventDate = dateStr => {
    if (!dateStr || typeof dateStr !== 'string') return null;
    const trimmed = dateStr.trim();

    // 1. YYYY-MM-DD or YYYY/MM/DD
    const isoMatch = trimmed.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})/);
    if (isoMatch) {
        const [, y, m, d] = isoMatch;
        const date = new Date(parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10));
        if (!isNaN(date.getTime())) return { date, year: parseInt(y, 10), month: parseInt(m, 10) - 1, day: parseInt(d, 10) };
    }

    // 2. DD. MM. YYYY. (European dot notation with optional spaces and optional trailing dot)
    const dotMatch = trimmed.match(/^(\d{1,2})\.\s*(\d{1,2})\.\s*(\d{4})\.?/);
    if (dotMatch) {
        const [, d, m, y] = dotMatch;
        const date = new Date(parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10));
        if (!isNaN(date.getTime())) return { date, year: parseInt(y, 10), month: parseInt(m, 10) - 1, day: parseInt(d, 10) };
    }

    // 3. DD/MM/YYYY or DD-MM-YYYY
    const slashMatch = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
    if (slashMatch) {
        const [, d, m, y] = slashMatch;
        const date = new Date(parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10));
        if (!isNaN(date.getTime())) return { date, year: parseInt(y, 10), month: parseInt(m, 10) - 1, day: parseInt(d, 10) };
    }

    // 4. Fallback to native Date parser (e.g. "Sep 14, 2026")
    const fallback = new Date(trimmed);
    if (!isNaN(fallback.getTime())) {
        return { date: fallback, year: fallback.getFullYear(), month: fallback.getMonth(), day: fallback.getDate() };
    }

    return null;
};
